export const LOADER_COUNTRIESUSER             =    'LOADER_COUNTRIESUSER';
export const GET_COUNTRIESUSER                =    'GET_COUNTRIESUSER';
export const COUNTRIESUSER_FAIL               =    'COUNTRIESUSER_FAIL';
export const SAVE_LOADER_COUNTRIESUSER        =    'SAVE_LOADER_COUNTRIESUSER';
export const FORM_COUNTRIESUSER_FAIL          =    'FORM_COUNTRIESUSER_FAIL';

